import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup,             // <--- Changed from Redirect to Popup
  signInWithEmailAndPassword,  // <--- Added Email Auth
  signOut,
  onAuthStateChanged 
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC0sYpeX0kb2CT6xRN7NSt-ySOU8Dyhr5s",
  authDomain: "dmp-ugc-ad-generator.firebaseapp.com",
  projectId: "dmp-ugc-ad-generator",
  storageBucket: "dmp-ugc-ad-generator.firebasestorage.app",
  messagingSenderId: "308174437740",
  appId: "1:308174437740:web:d9679994be4b6c8b78c749"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Optional: Keep the domain restriction if you want
googleProvider.setCustomParameters({ hd: "drivemp.com" });

// 1. USE POPUP (Easier than redirect)
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);

// 2. ADD EMAIL LOGIN FUNCTION
export const loginWithEmail = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
}

export const logOut = () => signOut(auth);

export const onAuthParamChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};